import { openBlock as h, createElementBlock as e, createElementVNode as l } from "vue";
const t = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, o = /* @__PURE__ */ l("path", {
  fill: "#F0F0F0",
  d: "M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20Z"
}, null, -1), n = /* @__PURE__ */ l("path", {
  fill: "#0052B4",
  d: "M20 40c6.062 0 11.493-2.697 15.16-6.956H4.84C8.507 37.303 13.939 40 19.999 40Zm20-20C40 8.954 31.046 0 20 0S0 8.954 0 20c0 1.805.24 3.554.689 5.217H39.31A19.99 19.99 0 0 0 40 20Z"
}, null, -1), c = /* @__PURE__ */ l("path", {
  fill: "#D80027",
  d: "M1.59 27.826c.385.906.836 1.777 1.345 2.609h34.13c.509-.832.96-1.703 1.345-2.609H1.59Z"
}, null, -1), s = /* @__PURE__ */ l("path", {
  fill: "#FFDA44",
  d: "m14.296 21.304.324.997h1.048l-.848.616.324.996-.848-.616-.848.616.324-.996-.847-.616h1.047l.324-.997Zm0 13.044.324.996h1.048l-.848.616.324.997-.848-.616-.848.616.324-.997-.847-.616h1.047l.324-.996Zm-6.072-4.411.324.996h1.048l-.848.616.324.996-.848-.616-.847.616.324-.996-.848-.616h1.048l.323-.996Zm2.319-7.328.324.996h1.048l-.848.616.324.997-.848-.616-.847.616.324-.997-.848-.616h1.048l.323-.996Zm-3.69 4.103H7.9l.324-.996.324.996h1.048l-.848.616.324.996-.848-.615-.847.615.323-.996-.847-.616Zm2.843 8.75.324-.996-.848-.616h1.048l.324-.997.323.997h1.048l-.848.615.324.997-.848-.616-.847.616Zm10.669-5.525-.323.996h-1.048l.847.616-.323.996.847-.616.848.616-.324-.996.848-.616h-1.048l-.324-.996Zm-2.319-7.328-.324.996h-1.047l.847.616-.324.997.848-.616.848.616-.324-.997.848-.616H18.37l-.324-.996Zm3.691 4.103h-1.048l-.324-.996-.323.996h-1.048l.847.616-.323.996.847-.616.848.616-.324-.996.848-.616Zm-2.843 8.75-.324-.996.848-.616H18.37l-.324-.997-.324.997h-1.047l.847.615-.323.997.847-.616.848.616Z"
}, null, -1), m = [
  o,
  n,
  c,
  s
];
function d(i, Z) {
  return h(), e("svg", t, [...m]);
}
const r = { render: d };
export {
  r as default,
  d as render
};
